export class AppConsts {

    static readonly tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';

    static remoteServiceBaseUrl: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'MarMazJob'
    };

    static readonly authorization = {
        encryptedAuthTokenName: 'enc_auth_token'
    };
    static readonly maxResultCount = {
        maxResultCountValue: 2147483647
    };
}
